var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H117V117H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.501 0C26.2352 0 0 26.2371 0 58.501C0 90.7648 26.2352 117 58.501 117C90.7648 117 117 90.7648 117 58.501C117 26.2371 90.6802 0 58.501 0ZM58.501 113.519C28.1038 113.519 3.3969 88.8117 3.3969 58.501C3.3969 28.1038 28.1038 3.3969 58.501 3.3969C88.8962 3.3969 113.603 28.1038 113.603 58.501C113.519 88.8117 88.8117 113.519 58.501 113.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7571 34.3013C94.586 34.1321 94.4168 33.9629 94.2476 33.7918C94.2476 33.7918 94.2476 33.7073 94.1611 33.7073C93.9074 33.6227 93.7382 33.5381 93.4825 33.5381H23.5201C23.2664 33.5381 23.0107 33.6227 22.8415 33.7073L22.7569 33.7918C22.5013 33.8784 22.3321 34.0475 22.2475 34.3013C22.1629 34.3878 22.1629 34.3878 22.1629 34.4724C21.9918 34.7261 21.9072 34.9818 21.9072 35.3202V73.359C21.9072 78.8782 26.323 83.2921 31.8403 83.2921H85.3315C90.8507 83.2921 95.2665 78.7917 95.2665 73.359V35.3202C95.2665 34.9818 95.18 34.7261 95.0108 34.4724C94.8417 34.4724 94.8417 34.3878 94.7571 34.3013ZM88.6438 37.0196L58.5023 61.5573L28.2743 37.0196H88.6438ZM91.7004 73.359C91.7004 76.925 88.7284 79.8971 85.1623 79.8971H31.6712C28.1051 79.8971 25.133 76.925 25.133 73.359V38.8862L57.3123 65.0388C57.9063 65.5482 58.8406 65.5482 59.4347 65.0388L91.7004 38.8862V73.359Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.be7303a08a020181f31440666b578219.svg";
export { ForwardRef as ReactComponent };